





























































































































































































































































































































































import {Component, Vue} from 'nuxt-property-decorator'
import Swiper, { Navigation, Pagination } from 'swiper'
// eslint-disable-next-line import/no-named-as-default
import 'swiper/swiper.scss'

Swiper.use([Navigation, Pagination])

@Component({
    layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
})
export default class Franchise extends Vue {
    // layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
    
    private swiper: any = null

    private form = {
        city: '',
        name: '',
        phone: '',
        accepted: false
    }
    
    private isSubmitting = false
    private successMessage = ''
    private errorMessage = ''
    
    
    mounted(){
        this.initSwiper()
    }


    beforeDestroy() {
        if (this.swiper) {
            this.swiper.destroy()
        }
    }

    private initSwiper() {
        this.swiper = new Swiper(this.$refs.franchiseSlider, {
        // slidesPerView: 2,
        spaceBetween: 16,
        // loop: true,
        // mousewheel: true,
        navigation: {
            nextEl: this.$refs.franchiseSliderNext,
            prevEl: this.$refs.franchiseSliderPrev,
        },
        pagination: {
            el: this.$refs.franchiseSliderPagination,
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1
            },
            768: {
                slidesPerView: 2
            }
        }
    })
    }


    private get formAccepted(): boolean {
        return this.form.accepted
    }

    private get isAgreementError(): boolean {
        return !this.form.accepted && this.errorMessage === 'Необходимо согласие с условиями обработки персональных данных'
    }

    // Отправка формы
    private async submitForm() {
        // Сброс сообщений
        this.successMessage = ''
        this.errorMessage = ''

        // Валидация
        if (!this.form.city.trim()) {
            this.errorMessage = 'Пожалуйста, укажите город'
            return
        }

        if (!this.form.name.trim()) {
            this.errorMessage = 'Пожалуйста, укажите имя'
            return
        }

        if (!this.form.phone.trim() || this.form.phone.includes('_')) {
            this.errorMessage = 'Пожалуйста, укажите корректный номер телефона'
            return
        }

        if (!this.form.accepted) {
            this.errorMessage = 'Необходимо согласие с условиями обработки персональных данных'
            return
        }

        this.isSubmitting = true

        try {
            // Отправка данных на сервер
            const response = await fetch('/local/api/franchise.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    city: this.form.city,
                    name: this.form.name,
                    phone: this.form.phone,
                    page_url: window.location.href,
                    timestamp: new Date().toISOString()
                })

            })
                .then(response => {
                    //if (response.success == true) {
                        this.successMessage = 'Спасибо! Ваша заявка успешно отправлена. Мы свяжемся с вами в ближайшее время.'
                        
                        // Сброс формы
                        this.form = {
                            city: '',
                            name: '',
                            phone: '',
                            accepted: false
                        }

                        // Сброс сообщения через 5 секунд
                        setTimeout(() => {
                            this.successMessage = ''
                        }, 5000)
                        console.log('form sending')
                    //} else {
                        //this.errorMessage = response.message || 'Произошла ошибка при отправке. Попробуйте еще раз.'
                    //}
                })
                .catch(response => {
                    this.errorMessage = response.message || 'Произошла ошибка при отправке. Попробуйте еще раз.'
                })

            
        } catch (error) {
            console.error('Ошибка отправки формы:', error)
            this.errorMessage = 'Произошла ошибка при отправке. Пожалуйста, попробуйте позже или свяжитесь с нами другим способом.'
        } finally {
            this.isSubmitting = false
        }
    }
}

